import { IntlProvider } from 'react-intl';
import { ReactNode } from 'react';
import { connect } from 'react-redux';
import getLocale from '../getLocale';
import translations from '../messages/translations';

type Locale = keyof typeof translations;

interface OwnProps {
  children: ReactNode;
}

interface StateProps {
  user: { locale?: string } | null;
}

const ReactIntlProvider = ({ user, children }: OwnProps & StateProps) => {
  const locale = ((user && user.locale) || getLocale()) as Locale;

  return (
    <IntlProvider locale={locale} messages={translations[locale]}>
      {children}
    </IntlProvider>
  );
};

const mapStateToProps = ({ user: { user } }: any): StateProps => ({ user });

export default connect<StateProps, {}, OwnProps>(mapStateToProps)(ReactIntlProvider);
